import React from "react";

import { LandingPageProps } from "./LandingPage.types";

import "./LandingPage.scss";
import Container from "../../atoms/Container/Container";

const LandingPage: React.FC<LandingPageProps> = ({ hero }) => (
  <div data-testid="LandingPage" className="mp-templates-landingpage--main">
    <Container>
      <div className="hero">{hero}</div>
    </Container>
  </div>
);

export default LandingPage;
